import React, { useState } from "react";
import { animated, useSpring } from "react-spring";

import Chatbox from "../Chatbox";
import { CommentProps } from "../Comment/Comment";
import { NavLink } from "react-router-dom";
import ProfileImage from "../ProfileImage";
import TimeAgo from "../TimeAgo";
import addReply from "../../helpers/addReply";
import useCurrentUser from "../../hooks/useCurrentUser";
import useEvent from "../../hooks/useEvent";

export interface ChatBubbleProps extends CommentProps {}

const ChatBubble = ({
  user,
  message,
  time,
  replies,
  commentID,
}: ChatBubbleProps) => {
  const event = useEvent();
  const currentUser = useCurrentUser();
  const [isReplying, setIsReplying] = useState(false);
  const { image, firstname, lastname, email, ID } = user || {};

  const handleNewMessage = (comment: string) => {
    setIsReplying(false);

    if (commentID && currentUser) {
      const userID = currentUser.ID;
      addReply(userID, comment, commentID);
    }
  };

  // Animation
  const animation = useSpring({
    opacity: "1",
    transform: "translateY(0px)",
    from: {
      opacity: "0",
      transform: "translateY(10px)",
    },
  });

  return (
    <>
      <animated.div className="flex justify-between" style={animation}>
        <div className="w-2/12">
          <NavLink to={`/${event}/profiles/${ID}`}>
            <ProfileImage src={image} />
          </NavLink>
        </div>
        <div className="w-full ml-4 space-y-4">
          <div className="p-4 space-y-2 bg-gray-200 rounded-xl">
            <div className="text-sm font-medium">
              <NavLink to={`/${event}/profiles/${ID}`}>
                {firstname && lastname
                  ? `${firstname} ${lastname}`
                  : email
                  ? email
                  : ID
                  ? ID
                  : "Anonymous User"}
              </NavLink>
            </div>
            <p className="text-sm font-light">{message}</p>
            <div className="flex items-center space-x-4">
              <button
                type="button"
                className="text-xs font-medium text-black uppercase transition-colors duration-300 ease-in hover:text-gray-400"
                onClick={() => setIsReplying((toggle) => !toggle)}
              >
                {isReplying ? "Cancel" : "Reply"}
              </button>
              <div className="text-sm font-light text-gray-400">
                <TimeAgo time={time} />
              </div>
            </div>
          </div>

          {isReplying ? <Chatbox onNewMessage={handleNewMessage} /> : null}
        </div>
      </animated.div>
      <div className="mt-4 space-y-4">
        {replies?.map((reply, key) => (
          <ChatBubble key={key} {...reply} />
        ))}
      </div>
    </>
  );
};

export default ChatBubble;
